import { render, staticRenderFns } from "./Simple3d.vue?vue&type=template&id=4cea5a3d&scoped=true&"
import script from "./Simple3d.vue?vue&type=script&lang=js&"
export * from "./Simple3d.vue?vue&type=script&lang=js&"
import style0 from "./Simple3d.vue?vue&type=style&index=0&id=4cea5a3d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea5a3d",
  null
  
)

export default component.exports